<template>
    <InternalNav/>
    <router-view/>
</template>

<script>
import InternalNav from "@/components/Headers/InternalNav";
export default {
    components: {
        InternalNav
    }
};
</script>